import dbConnection from "../dbConnection";

const automationsApi = {
  getAutomations: function () {
    return dbConnection.get("api/admin/automations");
  },
  getSingleAutomation: function (id) {
    return dbConnection.get("api/admin/automations/id/" + id);
  },
  saveAutomation: function (payload) {
    return dbConnection.post("api/admin/automations", payload);
  },
  getTemplates: function (type) {
    return dbConnection.get("api/admin/automations/templates/" + type);
  },
  getMailTemplates: function () {
    return dbConnection.get("api/admin/automations/mailTemplates");
  },
  getSingleMailTemplate: function (id) {
    return dbConnection.get("api/admin/automations/mailTemplates/" + id);
  },
  saveMailTemplate: function (payload) {
    return dbConnection.post("api/admin/automations/mailTemplates", payload);
  },
  getNoticeTemplates: function () {
    return dbConnection.get("api/admin/automations/noticeTemplates");
  },
  getSingleNoticeTemplate: function (id) {
    return dbConnection.get("api/admin/automations/noticeTemplates/" + id);
  },
  saveNoticeTemplate: function (payload) {
    return dbConnection.post("api/admin/automations/noticeTemplates", payload);
  },
  previewData: function (payload) {
    return dbConnection.post("api/admin/automations/previewData", payload);
  },
  executeAutomation: function (payload) {
    return dbConnection.post(
      "api/admin/automations/executeManualAutomation",
      payload
    );
  },
  sendTest: function (payload) {
    return dbConnection.post("api/admin/automations/sendTest", payload);
  },
  getLogs: function (page, filterAutomationId) {
    if (!filterAutomationId) {
      filterAutomationId = 0;
    }
    return dbConnection.get(
      "api/admin/automations/logs/" + page + "/" + filterAutomationId
    );
  },
  getDetailedLogs: function (automationId, page) {
    return dbConnection.get(
      "api/admin/automations/detailedLogs/" + automationId + "/" + page
    );
  },
  getRawMailgunTemplates: function () {
    return dbConnection.get("api/admin/automations/rawMailgunTemplates");
  },
  getAutomationStats: function (automationTag, duration) {
    return dbConnection.get(
      "api/admin/automations/tagStats/" + automationTag + "/" + duration
    );
  },
  deleteItem: function (type, id) {
    return dbConnection.delete(
      "api/admin/automations/remove/" + type + "/" + id
    );
  },
  duplicateItem: function (type, id) {
    return dbConnection.get(
      "api/admin/automations/duplicate/" + type + "/" + id
    );
  },
  updateField: function (field, payload) {
    return dbConnection.post(
      "api/admin/automations/updateField/" + field,
      payload
    );
  },
  sendPreviewEmail: function (payload) {
    return dbConnection.post("api/admin/automations/sendPreviewEmail", payload);
  },
  getAutomationSchedule: function (id) {
    return dbConnection.get("api/admin/automations/upcomingSchedule/" + id);
  },
};

export default automationsApi;
